import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const doesAppointmentExist = (axios, { clinicReferenceId, employeeReferenceId, start, end }) => async () => {
  const url = `/api/v1/internal/appointments/exists`;
  const params = {
    clinicReferenceId,
    employeeReferenceId,
    start,
    end
  };
  const { data } = await axios.get(url, { params });
  return data;
};
const useDoesAppointmentExist = ({ params, auth }) => {
  const { echoCore } = useAxiosProvider();
  const enabled = !!echoCore && !!auth && !!params.clinicReferenceId && !!params.employeeReferenceId && !!params.start && !!params.end;
  const queryKey = ["appointment-exists", params];
  const { data, ...queryResult } = useQuery({
    queryKey,
    queryFn: doesAppointmentExist(echoCore, params),
    enabled
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useDoesAppointmentExist
};
